import React from "react";
import { Box } from "@chakra-ui/react";
import { MdGroups, MdErrorOutline } from "react-icons/md";
import useGroupDetail from "../../groupsManage/hooks/useGroupDetail";
import GroupDetailHeader from "../../groupsManage/detail/GroupDetailHeader";
import GroupDetailTabs from "../../groupsManage/detail/GroupDetailTabs";
import { InspectorShell, InspectorCentered } from "./InspectorShell";

/**
 * Group inspector hosted in the shared inspector shell. Reuses the existing
 * (already light) group detail header + tabs that previously lived in a drawer,
 * so all group admin actions are preserved inside the unified right column.
 * @param {Object} props
 * @param {number|string|null} props.groupId - Selected group id
 * @param {number} props.userRight - Connected admin's right level
 * @param {Function} props.onChanged - Notifies the list when a group changed
 * @param {Function} props.onDeleted - Notifies the list when a group was deleted
 * @param {Function} props.onClose - Clears the current selection
 * @returns {React.ReactElement}
 */
function GroupInspector({ groupId, userRight, onChanged, onDeleted, onClose }) {
    const { detail, loading, error, refresh } = useGroupDetail(groupId);
    const handleChanged = (updated) => { refresh(); onChanged?.(updated); };

    if (loading) return <InspectorCentered spin label="Chargement du groupe…" />;
    if (error) return <InspectorCentered icon={MdErrorOutline} tone="red.400" label={typeof error === "string" ? error : "Erreur de chargement"} />;
    if (!detail) return <InspectorCentered icon={MdGroups} label="Groupe introuvable" />;

    const header = (
        <Box px="16px" pt="14px">
            <GroupDetailHeader group={detail} onClose={onClose} onChanged={handleChanged}
                onDeleted={onDeleted} onRefresh={refresh} />
        </Box>
    );
    return (
        <InspectorShell header={header}>
            <GroupDetailTabs detail={detail} onRefresh={refresh} onChanged={handleChanged} userRight={userRight} />
        </InspectorShell>
    );
}

export default GroupInspector;
